(() => {
  const PRODUCT_ROOT_SELECTOR = '[data-product-root]';

  const getQuantityLimit = (value) => {
    const parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
  };

  const updateQuantity = (input, option) => {
    if (!input || !option) return;

    const minimum = getQuantityLimit(option.dataset.quantityMin) || 1;
    const increment = getQuantityLimit(option.dataset.quantityIncrement) || 1;
    const maximum = getQuantityLimit(option.dataset.quantityMax);
    const currentValue = getQuantityLimit(input.value) || minimum;
    const boundedValue = maximum ? Math.min(Math.max(currentValue, minimum), maximum) : Math.max(currentValue, minimum);
    const nextValue = minimum + Math.floor((boundedValue - minimum) / increment) * increment;

    input.min = String(minimum);
    input.step = String(increment);
    input.value = String(nextValue);

    if (maximum) {
      input.max = String(maximum);
    } else {
      input.removeAttribute('max');
    }
  };

  const setMainImage = (root, imageId) => {
    if (!imageId) return;

    const thumbnail = root.querySelector(`[data-product-thumbnail][data-product-image-id="${imageId}"]`);
    const mainImage = root.querySelector('#ProductGalleryMainImage');
    if (!thumbnail || !mainImage) return;

    mainImage.src = thumbnail.dataset.productImageSrc;
    mainImage.srcset = thumbnail.dataset.productImageSrcset;
    mainImage.alt = thumbnail.dataset.productImageAlt;

    root.querySelectorAll('[data-product-thumbnail]').forEach((item) => {
      const isCurrent = item === thumbnail;
      item.classList.toggle('is-current', isCurrent);
      item.setAttribute('aria-current', String(isCurrent));
    });
  };

  const updateProductState = (root, variant, option) => {
    if (!variant || !option) return;

    const price = root.querySelector('[data-product-price-current]');
    const comparePrice = root.querySelector('[data-product-price-compare]');
    const comparePriceValue = root.querySelector('[data-product-price-compare-value]');
    const sku = root.querySelector('[data-product-sku]');
    const skuValue = root.querySelector('[data-product-sku-value]');
    const availability = root.querySelector('[data-product-availability]');
    const submit = root.querySelector('[data-product-submit]');
    const quantity = root.querySelector('[data-product-quantity-input]');

    if (price) price.textContent = option.dataset.price;

    if (comparePrice && comparePriceValue) {
      const compareAtPrice = option.dataset.compareAtPrice;
      comparePriceValue.textContent = compareAtPrice;
      comparePrice.hidden = !compareAtPrice;
    }

    if (sku && skuValue) {
      const variantSku = option.dataset.sku;
      skuValue.textContent = variantSku;
      sku.hidden = !variantSku;
    }

    if (availability) {
      availability.textContent = variant.available ? 'Disponible' : 'Agotado';
      availability.classList.toggle('product-form__availability--available', variant.available);
      availability.classList.toggle('product-form__availability--sold-out', !variant.available);
    }

    if (submit) {
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? submit.dataset.addToCartLabel : submit.dataset.soldOutLabel;
    }

    updateQuantity(quantity, option);

    const featuredMedia = variant.featured_media || variant.featured_image;
    if (featuredMedia && featuredMedia.id) {
      setMainImage(root, String(featuredMedia.id));
    }
  };

  const initializeRoot = (root) => {
    const variantData = root.querySelector('[data-product-variants]');
    const form = root.querySelector('[data-product-form]');
    if (!variantData || !form) return;

    let variants;
    try {
      variants = JSON.parse(variantData.textContent);
    } catch {
      return;
    }

    const variantsById = new Map(variants.map((variant) => [String(variant.id), variant]));
    const select = form.querySelector('[data-product-variant-select]');
    const selectField = form.querySelector('[data-product-variant-select-field]');
    const variantChips = form.querySelector('[data-product-variant-chips]');
    const hiddenVariantInput = form.querySelector('[data-product-variant-input]');
    const quantity = form.querySelector('[data-product-quantity-input]');
    const decrease = form.querySelector('[data-product-quantity-decrease]');
    const increase = form.querySelector('[data-product-quantity-increase]');

    root.querySelectorAll('[data-product-thumbnail]').forEach((thumbnail) => {
      thumbnail.addEventListener('click', (event) => {
        event.preventDefault();
        setMainImage(root, thumbnail.dataset.productImageId);
      });
    });

    if (select) {
      select.addEventListener('change', () => {
        const option = select.options[select.selectedIndex];
        updateProductState(root, variantsById.get(select.value), option);

        form.querySelectorAll('[data-product-variant-chip]').forEach((chip) => {
          const isSelected = chip.value === select.value;
          chip.checked = isSelected;
          chip.closest('.product-form__variant-chip')?.classList.toggle('is-selected', isSelected);
        });
      });
    }

    if (variantChips && select) {
      variantChips.hidden = false;
      if (selectField) selectField.classList.add('is-enhanced');
      variantChips.querySelectorAll('[data-product-variant-chip]').forEach((chip) => {
        chip.addEventListener('change', () => {
          if (!chip.checked) return;

          select.value = chip.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    }

    if (hiddenVariantInput) {
      const option = document.createElement('option');
      const variant = variantsById.get(hiddenVariantInput.value);
      if (variant) {
        option.dataset.quantityMin = String(variant.quantity_rule?.min || 1);
        option.dataset.quantityIncrement = String(variant.quantity_rule?.increment || 1);
        if (variant.quantity_rule?.max) option.dataset.quantityMax = String(variant.quantity_rule.max);
        updateQuantity(quantity, option);
      }
    }

    const changeQuantity = (direction) => {
      if (!quantity) return;

      const minimum = getQuantityLimit(quantity.min) || 1;
      const increment = getQuantityLimit(quantity.step) || 1;
      const maximum = getQuantityLimit(quantity.max);
      const currentValue = getQuantityLimit(quantity.value) || minimum;
      const nextValue = direction === 'increase' ? currentValue + increment : currentValue - increment;
      quantity.value = String(maximum ? Math.min(Math.max(nextValue, minimum), maximum) : Math.max(nextValue, minimum));
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
    };

    if (decrease && increase && quantity) {
      decrease.hidden = false;
      increase.hidden = false;
      decrease.addEventListener('click', () => changeQuantity('decrease'));
      increase.addEventListener('click', () => changeQuantity('increase'));
    }
  };

  document.querySelectorAll(PRODUCT_ROOT_SELECTOR).forEach(initializeRoot);
})();
